import { IonSpinner, IonCard, IonButton, useIonRouter, IonChip, IonToolbar, IonText, IonAvatar, IonCol, IonIcon, IonImg, IonItem, IonLabel, IonNote, IonRow, IonThumbnail, IonRippleEffect } from '@ionic/react';
import { lockClosed, heartCircle, chatboxOutline, heartCircleOutline, heartOutline, chatbubbleEllipses, earth, heart } from 'ionicons/icons';
import { ContentInfo, ContentInterface, ContentUpdateInt } from '../data/item';
import React, { Component }  from 'react';

import UserBar from '../components/UserBar'; 
import LikeBar from '../components/LikeBar'; 
import ActionComp from '../components/ActionComp'; 
import { LANGUAGE, GetStr } from "../language/Language";
import { ReadyAds, ShowAds } from "../components/Admob";

import '../pages/Main.css'; 

  
const TextContent : React.FC<ContentUpdateInt> = ({ content, index, onUpdate, view, autoplay }) => {
    
    const router = useIonRouter();

    // click on content
    const showContent = async () => {
        if (content.locked < 1 && view == "def")
        {
            let ready = await ReadyAds();
            if (!ready)
                router.push("/content/" + content.id + "/n", "forward", "push");
            else
            {
                ShowAds( () => {
                    router.push("/content/" + content.id + "/ad", "forward", "push");
                });
            }
        }
    }

    return (
        <div className="text-content">
            <UserBar content={content} index={index} onUpdate={onUpdate} view={view} autoplay={autoplay} />
            <IonItem lines="none" onClick={showContent}>
                <div className="ion-text-wrap">
            {
                content.title != "" ?
                <div className="content-title">{content.title}</div>
                :
            <div/>
            }

            {
                content.desc != "" ?
                <div className="content-desc ion-padding-bottom">{content.desc}</div>
                :
            <div/>
            }
                </div>
            </IonItem>
            
            {
                /* for content locked */
                content.locked > 1 ?
            <IonCard className="flat-card">
                <IonItem lines="none">
                    {
                        content.opening ?
                    <IonSpinner name="lines-sharp" slot="start" />
                        :
                    <IonIcon icon={lockClosed} slot="start"/>
                    }<br/>
                    <IonLabel>{ GetStr(LANGUAGE.TXT_SUPERLIKE_TO_UNLOCK_POST) }</IonLabel>
                </IonItem>
            </IonCard>
                :
                content.locked == 1 ?
            <IonCard className="flat-card">
                <IonItem lines="none">
                    {
                        content.opening ?
                    <IonSpinner name="lines-sharp" slot="start" />
                        :
                    <IonIcon icon={lockClosed} slot="start"/>
                    }<br/>
                    <IonLabel>{ GetStr(LANGUAGE.TXT_LIKE_TO_UNLOCK_POST) }</IonLabel>
                </IonItem>
            </IonCard>
                :
            <div/>
            }
            <ActionComp content={content} />
            <LikeBar content={content} index={index} onUpdate={onUpdate} view={view} autoplay={autoplay} />
        </div>
    );
};
  
export default TextContent;